var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Theme from '../../../raccoonTheme';
import WalletBar from '../../parts/WalletBar.vue';
import ToolBar from "../../parts/ToolBar.vue";
import BalanceModule from '../../mixins/BalanceModule';
export default Vue.extend({
    mixins: [BalanceModule],
    components: {
        ToolBar,
        WalletBar
    },
    name: "Balance",
    data() {
        return {
            styles: {
                xemAmount: {
                    fontSize: 'x-large',
                    textAlign: 'left',
                    marginLeft: '16px'
                },
                xemUnit: {
                    textAlign: 'right',
                    marginRight: '16px',
                    color: Theme.textDarkGray
                },
            },
        };
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetchBalance(true);
        });
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/detail/Balance.vue
// module id = 606
// module chunks = 1